import { NavLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';

import { colors, zIndex, devices } from '../../styles';

export const MobileHeaderLink = styled(NavLink)`
  text-decoration: none;
  text-transform: capitalize !important;
  margin: 8px 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${colors.mainGray};
`;

export const MobileHeaderTopLevelLink = styled(MobileHeaderLink)`
  font-weight: 500;
  color: ${colors.mainDark};
  margin: 8px 0;
  font-size: 18px;
  line-height: 22px;
`;

export const Divider = styled(Box)`
  border-top: 1px solid ${colors.gray};
  margin: 8px 0;
`;

export const MobileNavigation = styled(Box)`
  padding: 30px 16px 16px;
  display: flex;
  background: white;
  flex-direction: column;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);

  @media (${devices.sm}) {
    padding: 30px 20px 16px;
  }

  @media (${devices.md}) {
    padding: 30px 40px 16px;
  }
`;

export const MobileHeaderContainer = styled(Box)`
  width: 100%;
  background: rgba(34, 34, 34, 0.5);
  position: fixed;
  top: 0;
  z-index: ${zIndex.header};
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
`;

export const Container = styled(Box)`
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;

  @media (${devices.sm}) {
    padding: 8px 20px;
  }

  @media (${devices.md}) {
    padding: 8px 40px;
  }
`;

export const MenuButton = styled(IconButton)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 42px;
  height: 42px;
  padding: 8px;
  border: none;
  background: none;

  img {
    color: ${colors.mainDark};
    width: 100%;
  }
`;

export const LogoLink = styled(NavLink)`
  display: flex;
  background: ${colors.mainDark};
  padding: 10px;
  box-sizing: border-box;
  height: 44px;
  border-radius: 4px;

  img {
    height: 22px;
  }
`;

export const ContactUsButton = styled(Button)`
  text-transform: none;
  font-size: 14px;
  height: 42px;
  min-width: 125px;
  font-weight: 700;
`;

export const HeaderLinkGroupTitle = styled(Typography)`
  margin: 8px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: ${colors.mainDark};
`;
